<template>
  <div class="row-item">
    <label class="row-item__label" :style="{ width: width }"> {{ title }}: </label>
    <div class="row-item__content" :style="{ 'margin-left': width }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100px'
    },
    title: String
  },
  data() {
    return {}
  }
}
</script>
<style lang="less">
.row-item {
  margin-bottom: 8px;
  overflow: hidden;
  &::before {
    display: table;
    content: '';
  }
  &::after {
    display: table;
    content: '';
  }
  .row-item__label {
    text-align: left;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    word-break: break-all;
    color: #999;
    line-height: 18px;
    box-sizing: border-box;
  }
  .row-item__content {
    line-height: 18px;
    font-size: 14px;
    color: #333;
    word-break: break-all;
    min-height: 18px;
  }
}
</style>
